import { useEffect } from 'react';

export const useSessionFlags = (flagNames: string[]) => {
    useEffect(() => {
        for (const flagName of flagNames) {
            if (window.location.href.includes(flagName)) {
                window.sessionStorage.setItem(flagName, '1');
            }
        }
    }, []);
};
